import { render } from "./AuthSidebar.vue?vue&type=template&id=cacd3c64&scoped=true"
import script from "./AuthSidebar.vue?vue&type=script&lang=js"
export * from "./AuthSidebar.vue?vue&type=script&lang=js"

import "./AuthSidebar.vue?vue&type=style&index=0&id=cacd3c64&lang=scss&scoped=true"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cacd3c64"]])

export default __exports__